// 首页接口
import homeServer from './home'
// 分类接口
import categoryServer from './category'
// 购物车接口
import carServer from './car'
// 用户接口
import userServer from "./user";
// 订单接口
import orderServer from './order'
// 团购商品接口
import groupServer from './group'
const Api = Object.assign(
  {
    ...homeServer,
    ...categoryServer,
    ...carServer,
    ...userServer,
    ...orderServer,
    ...groupServer
  }
);
export default Api
